import platformLoop from '../assets/pre-login/platform-loop.svg';
import productCarbonAssessment from '../assets/pre-login/product-carbon-assessment.svg';
import productDashboardWeb from '../assets/pre-login/product-dashboard-web.svg';
import productDocumentManagement from '../assets/pre-login/product-document-management.svg';
import productGreenLoans from '../assets/pre-login/product-green-loans.svg';
import productReporting from '../assets/pre-login/product-reporting.svg';

/** Vector illustrations for the public pre-login landing page (hero and banner rows). */
export const PRE_LOGIN_IMAGES = {
  hero: productDashboardWeb,
  whyMeasure: productCarbonAssessment,
  climateSavings: platformLoop,
  pricing: productGreenLoans,
  benefitsDashboard: productDashboardWeb,
  benefitsDocuments: productDocumentManagement,
  benefitsReporting: productReporting,
  benefitsMsme: productGreenLoans,
  indiaContext: productReporting,
  workflowRegister: productDocumentManagement,
  workflowConnect: productDocumentManagement,
  workflowAssess: productCarbonAssessment,
  workflowReport: productReporting,
} as const;

export type PreLoginHighlightIcon =
  | 'climate'
  | 'finance'
  | 'reduction'
  | 'compliance'
  | 'scope'
  | 'savings'
  | 'insights'
  | 'offsets'
  | 'documents'
  | 'dashboard'
  | 'scale'
  | 'energy'
  | 'market'
  | 'msme';

export type PreLoginWorkflowIcon = 'register' | 'connect' | 'assess' | 'report';
